/**
 * Maximum file size allowed for document uploads (50MB)
 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024;
//# sourceMappingURL=fileConstants.js.map